module.exports = __webpack_public_path__ + "img/logo.0796e6b.svg";